import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../utils/EmblaCarouselArrowButtons';
import { addDotBtnsAndClickHandlers } from '../utils/EmblaCarouselDotButton';

export default (node) => {
  const init = () => {
    const emblaNode = node;

    const viewportNode = emblaNode.querySelector('.embla__viewport');
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
    const nextBtnNode = emblaNode.querySelector('.embla__button--next');
    const dotsNode = emblaNode.querySelector('.embla__dots');
    const controlsNode = emblaNode.querySelector('.embla__controls');

    const slidesToScroll = emblaNode.dataset.slidesToScroll
      ? Number(emblaNode.dataset.slidesToScroll)
      : 'auto';
    const options = { loop: false, slidesToScroll, align: 'start' };
    const emblaApi = EmblaCarousel(viewportNode, options);

    // Lazy load: defer off-screen slide images until they scroll into view
    const setupLazyLoading = () => {
      const slides = emblaApi.slideNodes();
      const inView = new Set(emblaApi.slidesInView());

      slides.forEach((slide, index) => {
        if (inView.has(index)) return;
        slide.querySelectorAll('img[src]').forEach((img) => {
          img.dataset.lazySrc = img.src;
          img.removeAttribute('src');
        });
      });

      const loadInViewImages = () => {
        const visibleSlides = emblaApi.slidesInView();
        visibleSlides.forEach((index) => {
          slides[index].querySelectorAll('img[data-lazy-src]').forEach((img) => {
            img.src = img.dataset.lazySrc;
            img.removeAttribute('data-lazy-src');
          });
        });
      };

      emblaApi.on('slidesInView', loadInViewImages);
    };

    setupLazyLoading();

    // Hide controls if there's nothing to scroll
    const updateControlsVisibility = () => {
      if (!controlsNode) return;
      const canScroll = emblaApi.canScrollPrev() || emblaApi.canScrollNext();
      controlsNode.style.display = canScroll ? '' : 'none';
    };

    updateControlsVisibility();
    emblaApi.on('init', updateControlsVisibility);
    emblaApi.on('resize', updateControlsVisibility);

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode
    );

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
      emblaApi,
      dotsNode
    );
  };

  init();
};
